export default __webpack_public_path__ + "static/media/laptop.445c0d8d.jpeg";